import { render, staticRenderFns } from "./ArticleFeedback.vue?vue&type=template&id=ec7c3894"
import script from "./ArticleFeedback.vue?vue&type=script&lang=ts"
export * from "./ArticleFeedback.vue?vue&type=script&lang=ts"
import style0 from "./ArticleFeedback.vue?vue&type=style&index=0&id=ec7c3894&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports